<template>
  <div class="content-box">
    <!-- <h3>出售流程</h3> -->

    <!-- <img src="../../assets/public/ic_deal_seller_flow_chart.png" /> -->

    <ol start="1">
      <li>
        消费0元、未开放交易的游戏、停服/停运、角色违规封禁的游戏小号无法出售；具体以出售页面显示为准。
      </li>

      <li>
        商品提交审核后，小号将被冻结无法登录；因等待造成的登录中断、道具及奖励流失，平台不具备赔偿责任。
      </li>

      <li>
        为确保信息真实，审核时可能对截图、描述进行修改或删除，以游戏内实际信息为准。
      </li>

      <li>
        审核及出售中时，可随时修改商品售价，修改后将重新进入审核期
      </li>

      <li>
        小号出售成功后，该小号下所有区服角色将会一并出售。
      </li>

      <li>
        交易成功收取5%手续费（最低5元），剩余收益以赠送余额发放，不支持提现。
      </li>

      <li>交易完成后，小号不支持找回。</li>

      <li>出售中账号一个月内未售出，系统将自动下架。</li>

      <li>
        使用虚假信息、截图作假、封禁角色等违规出售，将面临封号处理。
      </li>

      <li>
        因账号保管不当、共享泄露导致被盗售，平台不承担赔偿责任。
      </li>

      <li>
        本功能仅限小号交易，切勿违规转移，产生问题平台概不负责。
      </li>

      <li>
        系统实时监控数据，异常账号（批量倒卖、转移余额等）将直接封号。
      </li>
    </ol>
  </div>
</template>

<style scoped="scoped">
.content-box {
  padding-left: 24px;
  padding-right: 24px;
  background-color: #ffffff;
  color: #333;
  min-height: 100vh;
}

.content-box h3 {
  font-size: 37px;
  font-family: PingFang SC;
  font-weight: 650;
  color: #333;
  margin-top: 20px;
}

.content-box img {
  height: 97px;
  object-fit: fill;
  width: 100%;
  margin-top: 20px;
}

ol {
  margin-top: 10px;
}
ol li {
  list-style-type: decimal;
  list-style-position: inside;
  font-size: 30px;
  margin-top: 10px;
}
</style>
